import type { MerchantChecklistTerminalIssue } from '@pillar-portal/api-types';

export interface LogicalTerminalDisplayLabelInput {
    readonly name: string | null;
    readonly processor_name: string;
    readonly processor_mid: string;
    readonly processor_tid: string;
}

export interface MerchantAccountDisplayLabelInput {
    readonly name: string | null;
    readonly processor_name: string;
    readonly processor_mid: string;
}

export interface TerminalDeviceDisplayLabelInput {
    readonly name: string | null;
    readonly processor_name: string;
    readonly processor_mid: string;
    readonly processor_tid: string;
    readonly processor_device_id: string;
}

export function getTrimmedNameOrNull(name: string | null): string | null {
    const trimmedName: string = name?.trim() ?? '';
    return trimmedName.length > 0 ? trimmedName : null;
}

export function getMerchantChecklistTerminalName(
    merchantChecklistTerminalIssueTerminal: MerchantChecklistTerminalIssue['terminal']
): string | null {
    return getTrimmedNameOrNull(
        merchantChecklistTerminalIssueTerminal.terminal_device_uuid !== null
            ? merchantChecklistTerminalIssueTerminal.terminal_device_name
            : merchantChecklistTerminalIssueTerminal.logical_terminal_name
    );
}

export function getMerchantAccountDisplayLabel(input: MerchantAccountDisplayLabelInput): string {
    return `${input.processor_name} / ${getTrimmedNameOrNull(input.name) ?? input.processor_mid}`;
}

export function getLogicalTerminalDisplayLabel(input: LogicalTerminalDisplayLabelInput): string {
    return (
        getTrimmedNameOrNull(input.name) ??
        `${input.processor_name} / ${input.processor_mid} / ${input.processor_tid}`
    );
}

export function getTerminalDeviceDisplayLabel(input: TerminalDeviceDisplayLabelInput): string {
    return (
        getTrimmedNameOrNull(input.name) ??
        `${input.processor_name} / ${input.processor_mid} / ${input.processor_tid} / ${input.processor_device_id}`
    );
}
